import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { AccommodationType } from '../../../../../utils/api/filtersAPIResponseTypes';
import { getDynamicOptionsOrFallback, getOptionFromId } from '../../utils';

export enum PropertyTypes {
  Apartments = 'Apartments',
  Villas = 'Villas',
  GuestHouses = 'Guest_houses',
  BedAndBreakfasts = 'Bed_and_Breakfasts',
  Hotels = 'Hotels',
  Resorts = 'Resorts',
  CountryHouses = 'Country_houses',
  Campsites = 'Campsites',
  Aparthotel = 'Aparthotel',
  Hostels = 'Hostels',
  Motels = 'Motels',
  BoatHotels = 'Boat_Hotels',
  Riads = 'Riads',
  Ryokans = 'Ryokans',
}

export const propertyTypes = (t: TranslationFunction) => [
  {
    id: 1,
    name: 'hotels',
    text: t('vacation.search.filter.accommodation.type.hotels'),
    analytics: PropertyTypes.Hotels,
  },
  {
    id: 2,
    name: 'resorts',
    text: t('vacation.search.filter.accommodation.type.resorts'),
    analytics: PropertyTypes.Resorts,
  },
  {
    id: 3,
    name: 'apartments',
    text: t('vacation.search.filter.accommodation.type.apartments'),
    analytics: PropertyTypes.Apartments,
  },
  {
    id: 4,
    name: 'hostels',
    text: t('vacation.search.filter.accommodation.type.hostels'),
    analytics: PropertyTypes.Hostels,
  },
  {
    id: 5,
    name: 'motels',
    text: t('vacation.search.filter.accommodation.type.motels'),
    analytics: PropertyTypes.Motels,
  },
  {
    id: 6,
    name: 'countryhouses',
    text: t('vacation.search.filter.accommodation.type.countryhouses'),
    analytics: PropertyTypes.CountryHouses,
  },
  {
    id: 7,
    name: 'guesthouses',
    text: t('vacation.search.filter.accommodation.type.guesthouses'),
    analytics: PropertyTypes.GuestHouses,
  },
  {
    id: 8,
    name: 'bedandbreakfasts',
    text: t('vacation.search.filter.accommodation.type.bedandbreakfasts'),
    analytics: PropertyTypes.BedAndBreakfasts,
  },
  {
    id: 9,
    name: 'villas',
    text: t('vacation.search.filter.accommodation.type.villas'),
    analytics: PropertyTypes.Villas,
  },
  {
    id: 10,
    name: 'boatsandcruises',
    text: t('vacation.search.filter.accommodation.type.boatsandcruises'),
    analytics: PropertyTypes.BoatHotels,
  },
  {
    id: 11,
    name: 'campsites',
    text: t('vacation.search.filter.accommodation.type.campsites'),
    analytics: PropertyTypes.Campsites,
  },
  { id: 12, name: 'riads', text: t('vacation.search.filter.accommodation.type.riads'), analytics: PropertyTypes.Riads },
  {
    id: 13,
    name: 'ryokans',
    text: t('vacation.search.filter.accommodation.type.ryokans'),
    analytics: PropertyTypes.Ryokans,
  },
  {
    id: 14,
    name: 'aparthotels',
    text: t('vacation.search.filter.accommodation.type.aparthotels'),
    analytics: PropertyTypes.Aparthotel,
  },
];

const defaultAccommodations = [3, 9, 7, 8, 1, 2, 6, 11, 14, 4, 5, 10, 12, 13];

const getPropertyTypeOptions = ({
  accommodationType,
  t,
  isWaiting,
}: {
  accommodationType?: AccommodationType;
  t: TranslationFunction;
  isWaiting: boolean;
}) => {
  const accommodations = getDynamicOptionsOrFallback(accommodationType, defaultAccommodations);

  return accommodations
    .filter((x) => !!getOptionFromId(x, propertyTypes(t)))
    .map((x) => ({
      value: x,
      label: getOptionFromId(x, propertyTypes(t))?.text,
      ...(accommodationType ? { addLabel: accommodationType[x] ? `${accommodationType[x]}` : '0' } : {}),
      disabled: isWaiting || (accommodationType && !accommodationType[x]),
    }));
};

export default getPropertyTypeOptions;
